/**
 * Defaults enviados ao backend para a integração Pudu / ConversationApp.sendDelivery.
 * Ajuste aqui se o contrato da API Pudu exigir outros valores de `type` ou `delivery_sort`.
 */
export const RC3_INDOOR_DELIVERY_INTEGRATION_DEFAULTS = Object.freeze({
    type: 'delivery',
    delivery_sort: 'default',
});

/**
 * Chave estável para comparar pontos na UI (toggle / ordem), alinhada ao identificador do mapa.
 */
export function getMapPointSelectionKey(mapPoint) {
    if (!mapPoint || typeof mapPoint !== 'object') {
        return '';
    }
    if (mapPoint.id != null && String(mapPoint.id).trim() !== '') {
        return `id:${String(mapPoint.id)}`;
    }
    const ref =
        mapPoint.reference != null ? String(mapPoint.reference).trim() : '';
    const name = mapPoint.name != null ? String(mapPoint.name).trim() : '';
    return `ref:${ref}|name:${name}`;
}

/**
 * Valor enviado como `destination` em cada item de `destinations` (mesma regra do payload antigo).
 */
export function mapPointToDestinationValue(mapPoint) {
    if (!mapPoint || typeof mapPoint !== 'object') {
        return '';
    }
    if (
        mapPoint.reference != null &&
        String(mapPoint.reference).trim() !== ''
    ) {
        return String(mapPoint.reference);
    }
    if (mapPoint.id != null && String(mapPoint.id).trim() !== '') {
        return String(mapPoint.id);
    }
    return String(mapPoint.name || '').trim();
}

/**
 * Monta o body de POST /robots/delivery a partir do robô RC3 e de 1–N pontos (`map_points`).
 * Cada entrada em `destinations` corresponde a um ponto escolhido (até 3 no robô).
 *
 * @param {object} robot — objeto robô com `code` (ex.: RC3 / robots).
 * @param {object|object[]} mapPoints — um ponto ou lista não vazia de pontos.
 */
export function buildIndoorDeliveryRequestBody(robot, mapPoints) {
    if (!robot || !robot.code) {
        const err = new Error('MISSING_ROBOT_CODE');
        err.code = 'MISSING_ROBOT_CODE';
        throw err;
    }
    const list = Array.isArray(mapPoints) ? mapPoints : [mapPoints];
    if (!list.length || list.some(p => !p || typeof p !== 'object')) {
        const err = new Error('MISSING_MAP_POINT');
        err.code = 'MISSING_MAP_POINT';
        throw err;
    }

    const destinations = [];
    for (let i = 0; i < list.length; i += 1) {
        const destination = mapPointToDestinationValue(list[i]);
        if (!destination) {
            const err = new Error('MISSING_DESTINATION');
            err.code = 'MISSING_DESTINATION';
            throw err;
        }
        destinations.push({ destination });
    }

    return {
        robot_code: robot.code,
        destinations,
        ...RC3_INDOOR_DELIVERY_INTEGRATION_DEFAULTS,
    };
}
